// The attributes every free-text search or filter box carries, so a browser or
// a password manager treats it as a search field and never as a credential
// field (owner report 2026-10-12: Safari offered a saved login in the grid's
// "Filter" box on Logins > a login > organizations).
//
// - type="search" is the one that says "this is not a username": Safari's
//   Passwords AutoFill only considers plain text/email fields. autocomplete=
//   "off" alone is not enough; Safari ignores it for a field it takes to be a
//   username.
// - the data-* opt-outs are the documented "ignore this field" markers of
//   1Password, LastPass and Bitwarden, and `data-form-type="other"` is
//   Dashlane's.
// - the field's own `name` (never user, login, email or name) goes beside this
//   spread: `<input {...SEARCH_FIELD_PROPS} name="grid-filter" />`.
//
// A box that draws its own clear button also takes className
// "search-own-clear" (other.scss), which hides the browser's native ✕ so the
// two don't sit side by side.
export const SEARCH_FIELD_PROPS = {
  type: 'search',
  autoComplete: 'off',
  autoCorrect: 'off',
  autoCapitalize: 'off',
  spellCheck: false,
  inputMode: 'search',
  enterKeyHint: 'search',
  'data-1p-ignore': true,
  'data-lpignore': 'true',
  'data-bwignore': true,
  'data-form-type': 'other'
}
